<template>
  <div>
    <Button
      :size="15"
      color="#2c7bcd"
      colorText="#ffffff"
      tooltip="Duplicar Seleccionados"
      icon="fas fa-copy"
      round
      :width="30"
      class="mt-2 mb-3 mr-2"
      translate
      @click.native="showDuplicar();"
    />
    <ui-modal
      ref="modal3"
      title="Duplicar Seleccionados"
      class="modal-editar-simple-acuerdo-linea"
      size="auto"
      @close="ActionSetZindexModal(false)"
    >
      <div class="w-100" id="editarMultipleAcuerdoLineasModal">
        <data-table-acuerdos-lineas
          :headers="headers"
          :data="dataAux"
          idtabla="listado_confirmar_seleccionados2"
          :formulario="true"
          :acciones="[]"
          :load="load"
          customHeaders
          :filtroContenedores="filtroContenedores"
          :filtroCommodity="filtroCommodity"
          :filtroAtmosferas="filtroAtmosferas"
          :filtroColdtreatment="filtroColdtreatment"
        />
      </div>
      <!-- Footer -->
      <div class="d-flex justify-content-between mt-2">
        <button class="btn btn-default" @click="closeModal('modal3')">
          Cerrar
        </button>
        <button class="btn btn-outline-primary" @click="validarFormulario" id="buttonRefDuplicarAcuerdoLineas">
          Duplicar
        </button>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vue
import Vue from "vue";
// Vuex
import { mapState, mapActions } from "vuex";
// Toast
import VueToastify from "vue-toastify";
Vue.use(VueToastify);
// Common
import Button from "../../../../common/Button";
import DataTableAcuerdosLineas from "../../../../dataTables/tarifas/DataTableAcuerdosLineas";
import { 
  listarAcuerdosLineasByIds, 
  crearAcuerdoLinea,
  getListasAcuerdosBase 
} from "@/constants/lineas";

export default {
  props: ["acuerdoLineaArreglo", "idContrato", "dataPrueba", "getListaAcuerdosLineas"],
  data() {
    return {
      dataAux: [],
      load : false ,
      headers:[
        { title: "N°", width: "40px" },
        { title: "Naviera", width: "40px" },
        { title: "Naviera Salida", width: "40px" },
        { title: "POL", width: "50px" },
        { title: "POD", width: "30px" },
        { title: "Desde", width: "100px" },
        { title: "Hasta", width: "100px" },
        { title: "TT", width: "34px" },
        { title: "Neta (Costo)", width: "10px" },
        { title: "Pública (Venta)", width: "10px" },
        { title: "Descuento", width: "10px" },
        { title: "Unidad", width: "10px" },
        { title: "Commodity", width: "35px" },
        { title: "Atmósfera", width: "35px" },
        { title: "Trat. frío", width: "35px" },
        { title: "Dias Libres Origen", width: "10px" },
        { title: "Dias Plug Origen", width: "10px" },
        { title: "Dias Libres Destino", width: "10px" },
        { title: "Dias Plug Destino", width: "10px" },
        { title: "Genset", width: "10px" },
        { title: "Comentarios", width: "190px" },
        { title: "Tipo Contrato", width: "70px" },
        { title: "Contrato - Número", width: "70px" },
      ],
      filtroContenedores: [],
      filtroCommodity: [],
      filtroAtmosferas: [],
      filtroColdtreatment: [],
    };
  },

  components: {
    Button,
    DataTableAcuerdosLineas
  },
  computed: {
    ...mapState("lineas", [
      "dataListaNaviera",
      "dataListaPOD",
      "dataListaPOL",
      "dataListaNavierasNoUCC",
      "selectAtmospheres"
    ]),
    ...mapState([
      "puertos"
    ]),
  },
  methods: {
    ...mapActions(["ActionSetZindexModal"]),
    estadoButton(text, estado = true) {
      let buttonRef = document.querySelector("#buttonRefDuplicarAcuerdoLineas");
      buttonRef.innerHTML = text;
      buttonRef.disabled = estado;
    },
    async loadData() {
      let dataListas = await getListasAcuerdosBase();
      this.filtroContenedores = dataListas.filtro_contenedores;
      this.filtroCommodity    = dataListas.lista_prod_categories;
      this.filtroAtmosferas   = dataListas.lista_atmosferas;
      this.filtroColdtreatment = dataListas.lista_coldtreatment || [];
    },
    async showDuplicar() {

      if (this.acuerdoLineaArreglo.length === 0) {

        return this.$vToastify.warning(
          "Debe seleccionar Acuerdos de Líneas para duplicar.",
          "!Precaución¡"
        );

      }

      this.load = true ;

      this.openModal('modal3') ;

      await this.loadData();

      const data = await listarAcuerdosLineasByIds( { ids :this.acuerdoLineaArreglo } );

      this.dataAux = data.map( al => ({
        id : al.id,
        naviera : { id: al.naviera_id, name: al.naviera },
        naviera_salida : { id: al.naviera_salida_id, name: al.naviera_salida },
        pol : { id: parseInt(al.pol_id), name: al.pol },
        pod : { id: parseInt( al.pod_id ), name: al.pod },
        from_date : al.from_date,
        to_date : al.to_date,
        transit_time :al.transit_time,
        neta : al.neta,
        public_value : al.public_value,
        container_id : { id: al.container_id, code: al.unidad, ac: al.container_ac },
        product_container_id : { id: al.product_container_id, name: al.commodity },
        descuento: parseInt( al.public_value ) - parseInt( al.neta ),
        atmosphere_id : { id: al.atmosphere_id, name: al.atmosfera },
        coldtreatment: al.coldtreatment && al.coldtreatment !== "-" ? {
          id: al.coldtreatment_id || "",
          name: al.coldtreatment,
        } : {
          id: "",
          name: "",
        },
        free_days_embark : al.free_days_embark,
        plug_days_embark : al.plug_days_embark,
        free_days_land : al.free_days_land,
        plug_days_land : al.plug_days_land,
        genset : al.genset === "Si" ,
        get_out : al.get_out === "Si",
        comment : al.comment,
        tipo_contrato_id: { id: +al.tipo_contrato_id, name: al.tipo_contrato },
        tariff_contract_id: { id: +al.tariff_contract_id, name: al.contratoynumero},
        products_category_id: { id: al.product_container_id, name: al.commodity },
        contractsList: [],
        navieras_salida_list: al.naviera === "UCC" ? this.dataListaNavierasNoUCC : [{
          id: al.naviera_id,
          name: al.naviera
        }],
        atmospheres_list: al.container_ac === 0 ? this.selectAtmospheres.filter(item => item.id === 13) : this.selectAtmospheres.filter(item => item.id !== 13)
      }));

      this.load = false ;
    },
    async validarFormulario() {

      const form = this.ordenarData();

      let valid = true ;

      for (let tariff_lines of form.tariff_lines) {

        if (tariff_lines.naviera_id === "" || tariff_lines.naviera_id === undefined ) {
          this.$vToastify.error("Campo Naviera vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if (tariff_lines.naviera_salida_id === "" || tariff_lines.naviera_salida_id === undefined ) {
          this.$vToastify.error("Campo Naviera Salida vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if (tariff_lines.pol === "" || tariff_lines.pol === undefined ) {
          this.$vToastify.error("Campo POL vacío", "¡Error!");
          valid = false ;
          break ;
        }
        if (tariff_lines.pod === "" || tariff_lines.pod === undefined ) {
          this.$vToastify.error("Campo POD vacío", "¡Error!");
          valid = false ;
          break ;
        }
        if (tariff_lines.from_date === "" || tariff_lines.from_date === undefined ) {
          this.$vToastify.error("Campo DESDE vacío", "¡Error!");
          valid = false ;
          break ;
        }
        if (tariff_lines.to_date === "" || tariff_lines.to_date === undefined ) {
          this.$vToastify.error("Campo HASTA vacío", "¡Error!");
          valid = false ;
          break ;
        }
        if (tariff_lines.transit_time === "" || tariff_lines.transit_time === undefined ) {
          this.$vToastify.error("Campo TT vacío", "¡Error!");
          valid = false ;
          break ;
        }
        if (tariff_lines.neta === "" || tariff_lines.neta === undefined ) {
          this.$vToastify.error("Campo Neta (Costo) vacío", "¡Error!");
          valid = false ;
          break ;
        }
        if ( tariff_lines.public_value === "" || tariff_lines.public_value === undefined ) {
          this.$vToastify.error("Campo Pública (Venta) vacío", "¡Error!");
          valid = false ;
          break ;
        }
        if ( tariff_lines.container_id === "" || tariff_lines.container_id === undefined ) {
          this.$vToastify.error("Campo Unidad vacío", "¡Error!");
          valid = false ;
          break ;
        }
        if ( tariff_lines.products_category_id === "" || tariff_lines.products_category_id === undefined ) {
          this.$vToastify.error("Campo Commodity vacío", "¡Error!");
          valid = false ;
          break ;
        }
        if ( tariff_lines.atmosphere_id === "" || tariff_lines.atmosphere_id === undefined ) {
          this.$vToastify.error("Campo Atmósfera vacío", "¡Error!");
          valid = false ;
          break ;
        }
        if ( tariff_lines.free_days_embark === "" || tariff_lines.free_days_embark === undefined ) {
          this.$vToastify.error("Campo Free Days Origen vacío", "¡Error!");
          valid = false ;
          break ;
        }
        if ( tariff_lines.plug_days_embark === "" || tariff_lines.plug_days_embark === undefined ) {
          this.$vToastify.error("Campo Plug Days Origen vacío", "¡Error!");
          valid = false ;
          break ;
        }
        if ( tariff_lines.free_days_land === "" || tariff_lines.free_days_land === undefined ) {
          this.$vToastify.error("Campo Free Days Destino vacío", "¡Error!");
          valid = false ;
          break ;
        }
        if ( tariff_lines.plug_days_land === "" || tariff_lines.plug_days_land === undefined ) {
          this.$vToastify.error("Campo Plug Days Destino vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if ( tariff_lines.tipo_contrato === "" || tariff_lines.tipo_contrato === undefined ) {
          this.$vToastify.error("Campo Tipo Contrato vacío", "¡Error!");
          valid = false ;
          break ;
        }

        if ( tariff_lines.tariff_contract_id === "" || tariff_lines.tariff_contract_id === undefined || isNaN( tariff_lines.tariff_contract_id) ) {
          this.$vToastify.error("Campo Contrato - Número vacío", "¡Error!");
          valid = false ;
          break ;
        }

      }

      if( !valid ) return;

      this.estadoButton("Duplicando...");

      this.$vToastify.loader("Duplicando...");

      try {

        const data = await crearAcuerdoLinea( form );

        this.$vToastify.stopLoader();

        this.estadoButton("Duplicar", false);

        if( !data.error ){

          this.getListaAcuerdosLineas() ;

          this.closeModal('modal3') ;

          this.$vToastify.success("Acuerdos Lineas Duplicado Correctamente!","Solicitud realizada");

        } else {

          this.estadoButton("Duplicar", false);

          this.$vToastify.stopLoader();

          this.$vToastify.error("Error al duplicar campos, intente más tarde.", "¡Error!");

        }
      } catch (error) {

        this.estadoButton("Duplicar", false);

        this.$vToastify.stopLoader();

        this.$vToastify.error("Error al duplicar campos, intente más tarde.", "¡Error!");

      }
    },
    cambiaValorDescuento: function () {
      const descuento = parseInt(this.form.public_value.value) - parseInt(this.form.neta.value);
      this.discount = descuento < 0 ? 0 : descuento;
    },
    ordenarData() {
      return {
        tariff_lines : this.dataAux.map( al => ({
          id : al.id ,
          naviera_id : al.naviera.id ,
          naviera_salida_id : al.naviera_salida.id,
          pol : al.pol.id ,
          pod : al.pod.id ,
          atmosphere_id : al.atmosphere_id.id,
          coldtreatment :
            typeof al.coldtreatment === "object"
              ? (al.coldtreatment.name || "")
              : (al.coldtreatment || ""),
          container_id : al.container_id.id ,
          products_category_id : al.products_category_id.id ,
          public_value : al.public_value,
          from_date :  al.from_date ,
          to_date :  al.to_date ,
          transit_time :  al.transit_time ,
          neta : al.neta ,
          contract : '',
          free_days_embark: al.free_days_embark,
          plug_days_embark: al.plug_days_embark,
          free_days_land: al.free_days_land,
          plug_days_land: al.plug_days_land,
          genset: al.genset,
          get_out: al.get_out,
          tipo_contrato: al.tipo_contrato_id.id,
          tariff_contract_id: al.tariff_contract_id.id,
          comment: al.comment
        })),
        type: 'duplicar'
      };
    },
    openModal(ref) {
      this.ActionSetZindexModal(true);
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
    cerrarModal() {
      this.ActionSetZindexModal(false);
    },
  },
  mounted(){
    this.loadData();
  },
};
</script>

<style >
body #editarMultipleAcuerdoLineasModal .mx-datepicker {
  margin-left: 0px !important;
}


</style>
